import React from "react";
import { ChatMessageProps } from "@/types/chat";
import ChatMessageAssistant from './ChatMessageAssistant';
import ChatMessageUser from './ChatMessageUser';

const ChatMessage: React.FC<ChatMessageProps> = (props) => {
  // Route to the appropriate component based on message type
  if (props.message.type === 'assistant') {
    return <ChatMessageAssistant {...props} />;
  }
  
  return <ChatMessageUser {...props} />;
};

export default ChatMessage;
